import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      stroke: "#000",
      "stroke-width": "2",
      "stroke-opacity": "0.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 1 A9 9 0 0 1 19 10",
      stroke: "#AA1E2D",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }